/** @param {HTMLElement} button */
export const addRow = (button) => {
    const container = button.closest('[data-repeatable-fieldset]');
    const wrapper   = container.querySelector('[data-fieldset-template]').content.cloneNode(true).querySelector('[data-fieldset-row]');

    button.before(wrapper);
    button.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    wrapper.querySelector('input, textarea')?.focus();
};

/** @param {HTMLElement} button */
export const removeRow = (button) => {
    const row = button.closest('[data-fieldset-row]');

    row.hidden = true;
    row.querySelectorAll('[name]').forEach((input) => input.disabled = true);
};

/** @param {CustomEvent} event */
export const prepareSubmission = (event) => {
    const form = event.detail.elt.closest('form');

    if (!form) {
        return;
    }

    const containers = form.querySelectorAll('[data-repeatable-fieldset]');

    if (containers.length === 0) {
        return;
    }

    const parameters = Object.fromEntries(
        Object.entries(event.detail.parameters).filter(([key]) => {
            return ![...containers].some((container) => key.startsWith(container.dataset.repeatableFieldset + '['));
        }),
    );

    containers.forEach((container) => {
        const requestKey = container.dataset.repeatableFieldset;
        let index        = 0;

        container.querySelectorAll('[data-fieldset-row]:not([hidden])').forEach((row) => {
            row.querySelectorAll('input:not([disabled]), textarea:not([disabled]), select:not([disabled])').forEach((input) => {
                if (!input.name) {
                    return;
                }

                if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) {
                    return;
                }

                const field = input.name.replace(new RegExp(`^${requestKey}\\[\\d+]\\[(\\w+)]$`), '$1');

                parameters[`${requestKey}[${index}][${field}]`] = input.value;
            });

            index++;
        });
    });

    event.detail.parameters = parameters;
};
